// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"767":"05255cae7bb42cc7","894":"f10a6443d92595b7"}[chunkId] + ".js";
};